<template>
  <span class="pipe-container">
    <span class="pipe" :class="`pipe--${colour} pipe--${size}`"></span>
  </span>
</template>

<script>
export default {
  name: 'Pipe',
  props: {
    colour: {
      type: String,
      required: false,
      default: 'black',
      validate: ['black', 'grey', 'white', 'primary', 'secondary', 'teal', 'success'].includes,
    },
    size: {
      type: String,
      required: false,
      default: 'default',
      validate: ['default'].includes,
    },
  },
}
</script>
